import React, { useContext, useEffect, useMemo, useState } from "react";

import { GradeOpcoes, InputFile, InputText } from "../../../../components";
import { Grid, Button } from "@material-ui/core";

import Table from "../../../../components/grade/Table";
import ApiChartAccounts from "../../../../api/accounting/chartAccounts";
import { AppContext } from "../../../../App";
import TablePagination from "../../../../components/grade/TablePagination";
import ApiControllingArea from "../../../../api/accounting/controllingArea";
import { CostCentersValidate } from "../validates";

const initialValues = {
    cost_center_code: "",
    name: "",
    reference: "",
};

export default function CostCentersChange({ costCenters, setCostCenters, id, name }) {
    const { showMessageInfo, showMessageError, setLoading } = useContext(AppContext);

    const [costCenter, setCostCenter] = useState(initialValues);

    const [costCentersView, setCostCentersView] = useState([]);
    const [costCentersViewPage, setCostCentersViewPage] = useState(0);
    const [costCentersViewPerPage, setCostCentersViewPerPage] = useState(10);

    const metaData = useMemo(() => [
        {
            label: "Opções",
            render: (record, index) => {
                const options = [
                    { tipo: "edit", label: "Edição" },
                    { tipo: "remove", label: "Exclusão" },
                ];

                return (
                    <span>
                        <GradeOpcoes record={record} indexRecord={index} onClickOpcoes={onClickOptions} opcoes={options} />
                    </span>
                );
            },
        },
        { label: "Centro de Custo", field: "cost_center_code" },
        { label: "Nome", field: "name" },
        { label: "Referência", field: "reference" },
        { label: "Dh.Criação", field: "created_at", format: "datetime", minWidth: 160 },
        { label: "Dh.Atualização", field: "updated_at", format: "datetime", minWidth: 160 },
    ]);

    const onClickOptions = async (record, type, index) => {
        switch (type) {
            case "edit":
                setCostCenter({ ...record });
                break;
            case "remove":
                const costCentersCustom = [...costCenters];
                costCentersCustom.splice(index, 1);

                setCostCenters(costCentersCustom);
                break;
            default:
                break;
        }
    };

    const refreshCostCentersView = (page, perPage, costCenters) => {
        setCostCentersViewPerPage(perPage);
        setCostCentersViewPage(page);

        const initial = page === 0 ? 0 : perPage * page;
        const length = page === 0 ? perPage : perPage * (page + 1);

        setCostCentersView(costCenters.slice(initial, length));
    };

    const exportCostCenters = async () => {
        setLoading(true);
        try {
            const response = await ApiControllingArea().exportCostCenters(id, `Centros-Custo-${name || "Modelo"}`);

            if (!response.status) {
                showMessageError(response.message);
                return;
            }
        } finally {
            setLoading(false);
        }
    };

    const importCostCenters = async (e) => {
        setLoading(true);

        try {
            const file = e.target.files[Object.keys(e.target.files)[0]];

            const response = await ApiControllingArea().importCostCenters(file);

            if (!response.status) {
                showMessageError(response.message);
                return;
            }

            const costCentersImport = response.data;
            const costCentersCustom = [...costCenters];
            let created = 0,
                updated = 0;

            for (const costCenterImport of costCentersImport) {
                const costCenterIndex = costCentersCustom.findIndex((rec) => rec.cost_center_code === costCenterImport.cost_center_code);

                if (costCenterIndex === -1) {
                    costCentersCustom.push(costCenterImport);
                    created++;
                } else {
                    costCentersCustom[costCenterIndex].name = costCenterImport.name;
                    costCentersCustom[costCenterIndex].account_type = costCenterImport.account_type || null;
                    costCentersCustom[costCenterIndex].reference = costCenterImport.reference || null;
                    updated++;
                }
            }

            if (created || updated) {
                setCostCenters(costCentersCustom);
                refreshCostCentersView(0, costCentersViewPerPage, costCentersCustom);
            }

            showMessageInfo(["Centros de custo importadas com sucesso", `Novas: ${created}`, `Atualizadas: ${updated}`]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refreshCostCentersView(costCentersViewPage, costCentersViewPerPage, costCenters);
    }, [costCenters]);

    return (
        <>
            <Grid container spacing={1} style={{ paddingTop: "8px" }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={2}>
                        <InputText
                            required
                            label="Centro de Custo"
                            value={costCenter.cost_center_code}
                            onChangeValue={(e) => setCostCenter({ ...costCenter, cost_center_code: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            label="Nome"
                            value={costCenter.name}
                            onChangeValue={(e) => setCostCenter({ ...costCenter, name: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <InputText
                            label="Referência"
                            value={costCenter.reference}
                            onChangeValue={(e) => setCostCenter({ ...costCenter, reference: e.target.value })}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1} style={{ paddingTop: "8px", paddingBottom: "8px" }}>
                    <Grid item xs={12} sm={8}>
                        <Button
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px" }}
                            size="small"
                            variant="contained"
                            color="secondary"
                            onClick={() => setCostCenter(initialValues)}
                        >
                            Nova conta
                        </Button>
                        <Button
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginLeft: "5px" }}
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                                const costCenterIndex = costCenters.findIndex((rec) => rec.cost_center_code === costCenter.cost_center_code);
                                const costCentersCustom = [...costCenters];

                                // Validate
                                const validate = await ApiChartAccounts().apiDefault.validate(CostCentersValidate(), costCenter);
                                if (!validate.status) {
                                    showMessageError(validate.message);
                                    return;
                                }

                                if (costCenterIndex === -1) {
                                    costCentersCustom.push(costCenter);
                                } else {
                                    costCentersCustom[costCenterIndex] = costCenter;
                                }

                                setCostCenters(costCentersCustom);
                                setCostCenter(initialValues);
                            }}
                        >
                            Salvar
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginLeft: "5px" }}
                            color="default"
                            onClick={() => exportCostCenters()}
                        >
                            Exportar centros de custo
                        </Button>
                        <InputFile
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginLeft: "5px" }}
                            color="default"
                            onFileSelect={(e) => importCostCenters(e)}
                            fileExtension={".xlsx"}
                            label={"Importar centros de custo"}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Table dataSource={costCentersView} metaData={metaData} />
                <TablePagination
                    rowCount={costCenters.length || 0}
                    rowPage={costCentersViewPerPage}
                    page={costCentersViewPage}
                    onPageChange={(event, newPage) => {
                        refreshCostCentersView(newPage, costCentersViewPerPage, costCenters);
                    }}
                    onRowsPerPageChange={(event) => {
                        refreshCostCentersView(0, event.target.value, costCenters);
                    }}
                />
            </Grid>
        </>
    );
}
